'use client';

import { useTranslations } from 'next-intl';
import { HStack, VStack } from '@terra/ui-styled-system';
import { Badge } from '../../../../../components/badge';
import { Text } from '../../../../../components/styled/text';
import type { ParsedAdEntity } from './parse-ad-entities-output.util';

export function AdEntitiesListBody({
  entities,
}: {
  entities: ParsedAdEntity[];
}) {
  const t = useTranslations('designSystem.chat.adToolOutput');

  return (
    <VStack alignItems="stretch" gap={1.25} width="100%" overflowX="hidden">
      {entities.map((entity) => (
        <HStack key={entity.nodeId} gap={1.5} alignItems="center">
          <Badge size="sm" variant="emphasis">
            {entity.entityKind}
          </Badge>
          <Text fontSize="xs" color="fg.default" truncate flex={1}>
            {entity.displayName}
          </Text>
          {entity.isCrownJewel ? (
            <Text fontSize="2xs" color="fg.muted">
              {t('crown')}
            </Text>
          ) : null}
          <Text fontSize="2xs" color="fg.muted" fontFamily="mono" truncate>
            {entity.nodeId}
          </Text>
        </HStack>
      ))}
    </VStack>
  );
}
